import React from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton } from '../../../../Components/Utils/Buttons'
import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'
import FireSysytem from './fireSysytem'
import { ShieldCheck } from 'lucide-react'
import FireSysytemInsp from './fireSysytemInsp'

function IndexSurveyForm() {
    return(
        <div className='w-full h-full px-4 py-2'>
          <div className='w-full flex justify-between items-center'>
          <Breadcrumb
            items={[
              {
                name: "Settings",
              },
              {
                name: "Form"
              }
            ]}
          />
          <BackButton/>
          </div>
          <div className="w-full h-[calc(100vh-145px)]  mt-3 mx-auto rounded-md overflow-y-scroll">
            <div className=''>
         <div className="sticky top-0 z-40 bg-white p-4 border-b border-slate-200">
 
             <HeadingWithIcon icon={ShieldCheck} title="Forms" />

  </div>
          <div className="p-3 bg-white shadow-md rounded-b-lg">
              <FireSysytem/>
          </div>

          <div className="p-3 mt-4 bg-white shadow-md rounded-b-lg">
              <FireSysytemInsp/>
          </div>
                   
          </div>
        
          </div>
          </div>
      )
}

export default IndexSurveyForm
